import { useEffect, useState } from 'react';

import AsyncImage from 'dashboard/components-lib/AsyncImage';
import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SelfieFile } from 'dashboard/models/graph-hydration';
import ApiCanceledError from 'lib/errors/ApiCanceledError';
import { ApiEndpoint } from 'lib/interfaces/api';

interface GraphHoverCardSelfieImageProps {
  selfieFile: SelfieFile;
}

const GraphHoverCardSelfieImage = ({ selfieFile }: GraphHoverCardSelfieImageProps) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  useEffect(() => {
    // TODO: (bjon) We should really cache the image so that if we hover over the same account again
    // we do not trigger another call to the backend.
    if ('token' in selfieFile) {
      // clear any existing selfie blob while loading a new one
      setBlobUrl(null);
      const controller = new AbortController();
      const signal = controller.signal;
      const token = selfieFile.token;

      const endpoint = token.startsWith('act_') ? ApiEndpoint.Account : ApiEndpoint.Selfie;
      SessionClientDashboard.getBlob(endpoint, token, 'image', { signal })
        .then((blob) => {
          setBlobUrl(URL.createObjectURL(blob));
        })
        .catch((err) => {
          if (
            !(err instanceof ApiCanceledError) &&
            (!signal.aborted || err.reason !== 'component unmounted')
          ) {
            throw err;
          }
        });
      return () => {
        try {
          controller.abort('component unmounted');
        } catch (e) {
          // Ignore errors during unmount.
        }
      };
    } else if (selfieFile.id === 'DemoBackend') {
      setBlobUrl(selfieFile.filename);
      return;
    } else {
      // clear any existing selfie blob while loading a new one
      setBlobUrl(null);
      const controller = new AbortController();
      const signal = controller.signal;
      SessionClientDashboard.getBlob(ApiEndpoint.File, selfieFile.id, selfieFile.filename, {
        signal,
      })
        .then((blob) => {
          setBlobUrl(URL.createObjectURL(blob));
        })
        .catch((err) => {
          if (
            !(err instanceof ApiCanceledError) &&
            (!signal.aborted || err.reason !== 'component unmounted')
          ) {
            throw err;
          }
        });
      return () => {
        try {
          controller.abort('component unmounted');
        } catch (e) {
          // Ignore errors during unmount.
        }
      };
    }
  }, [selfieFile]);

  return (
    <AsyncImage
      // preview zoom + modal expand is incompatible with graph since other
      // actions can close the context menu
      allowPreviewZoom={false}
      allowModalExpand={false}
      imageUrl={blobUrl}
      width='auto'
      height='100px'
      referrerPolicy='no-referrer'
    />
  );
};

export default GraphHoverCardSelfieImage;
